import { businessContent } from '../assets/siteData';
import { Button } from '../components/Button';
import { Section } from '../components/Section';

export function BusinessesPage() {
  const { vappyTech, vappyShop, robotics } = businessContent;

  return (
    <Section
      eyebrow="Businesses"
      title="Services, tools, and brands we build with"
      description="VappyTech delivers client work across web, apps, design, and media. Below is exactly what we use and offer in development."
    >
      <div className="business-stack">
        <article className="business-card glass-panel">
          <div className="business-card__hero business-card__hero--gold">
            <p className="eyebrow">Service Brand</p>
            <h2>{vappyTech.title}</h2>
            <p>{vappyTech.subtitle}</p>
          </div>

          <div className="business-card__body">
            <div className="service-grid">
              {vappyTech.services.map((service) => (
                <div className="service-block" key={service.title}>
                  <div className="service-block__head">
                    <span className="service-block__icon" aria-hidden="true">
                      {service.iconType === 'web' && (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4 5H20M4 12H20M4 19H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                      {service.iconType === 'app' && (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="5" y="4" width="14" height="16" rx="3" stroke="currentColor" strokeWidth="1.8"/>
                          <circle cx="12" cy="17" r="1.2" fill="currentColor"/>
                        </svg>
                      )}
                      {service.iconType === 'uiux' && (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4 7H20M4 12H20M4 17H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                        </svg>
                      )}
                      {service.iconType === 'logo' && (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 4L19 12L5 20V4Z" fill="currentColor"/>
                        </svg>
                      )}
                      {service.iconType === 'video' && (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="3" y="5" width="14" height="14" rx="2" stroke="currentColor" strokeWidth="1.8"/>
                          <path d="M17 9L21 7V17L17 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                      {service.iconType === 'poster' && (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.8"/>
                          <path d="M7 8H17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                          <path d="M7 12H14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                        </svg>
                      )}
                    </span>
                    <div>
                      <h3>{service.title}</h3>
                      <p>{service.subtitle}</p>
                    </div>
                  </div>
                  <ul className="service-tools">
                    {service.tools.map((tool) => (
                      <li key={tool}>{tool}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <Button to="/contact">{vappyTech.cta}</Button>
          </div>
        </article>

        <article className="business-card glass-panel">
          <div className="business-card__hero business-card__hero--steel">
            <p className="eyebrow">Startup Brand</p>
            <h2>{vappyShop.title}</h2>
            <p>{vappyShop.subtitle}</p>
          </div>
          <div className="business-card__body">
            <ul className="feature-list">
              {vappyShop.highlights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Button href={vappyShop.href}>{vappyShop.cta}</Button>
          </div>
        </article>

        <article className="business-card glass-panel">
          <div className="business-card__hero business-card__hero--gold">
            <p className="eyebrow">Future Product Line</p>
            <h2>{robotics.title}</h2>
            <p>{robotics.subtitle}</p>
          </div>
          <div className="business-card__body">
            <ul className="feature-list">
              {robotics.focus.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Button to="/contact" variant="secondary">
              {robotics.cta}
            </Button>
          </div>
        </article>
      </div>
    </Section>
  );
}
